import type { AppAccessReason } from "@/types/api";
import { StudioApiError } from "@/types/api";

export function parseAccessReasonFromApiData(
  code: string | undefined,
  data: unknown,
): AppAccessReason | undefined {
  if (code !== "ACCESS_DENIED" || data == null || typeof data !== "object") {
    return undefined;
  }
  const reason = (data as { access_reason?: unknown }).access_reason;
  if (reason === "app_uninstalled" || reason === "app_suspended") {
    return reason;
  }
  return undefined;
}

export function isAppUninstalledError(error: unknown): boolean {
  return error instanceof StudioApiError && error.accessReason === "app_uninstalled";
}
